import http from '../http'
import { Res } from '../type'
import {
  SelfRegistrationDetail,
  SignDetailData,
  SignLeaveData,
  SignScanData,
  TrainingLink,
  TrainingPage,
  TrainingPageParams,
  TrainingTaskListData,
  TrainingTaskParams
} from '../Models/TrainingPage'
import { TrainingDetail, TrainingDetailParams } from '../Models/TrainingDetail'
import { TrainingMembers, TrainingMembersParams } from '../Models/TrainingMembers'
import {
  OtherTrainingInterfaceData,
  OtherTrainingParams,
  SignLeaveParams,
  SignScanParams,
  TrainingIntro,
  TrainingIntroParams
} from '../Models/TrainingIntro'
import { TrainingUpdateData, TrainingUpdateIDParams } from '../Models/TrainingUpdateId'
import {
  HomeworkDesc,
  HomeworkDescParams,
  SelfRegistrationDetailParams,
  TrainingOptParams
} from '../Models/HomeworkDesc'
import { HomeworkSubmitParams } from '../Models/HomeworkSubmit'

export const getTrainingPage = (params: TrainingPageParams): Res<TrainingPage> => {
  return http.request({
    url: '/sands-lms/api/v1/training/page',
    method: 'post',
    data: params,
    loadingShow: '0',
    toastShow: '0'
  })
}

export const getTrainingList = (params: TrainingDetailParams): Res<TrainingDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/training/get',
    method: 'get',
    params
  })
}

// 培训项目详情-展示成员
export const getTrainingMember = (params: TrainingMembersParams): Res<TrainingMembers> => {
  return http.request({
    url: '/sands-lms/api/v1/training/show-members',
    method: 'get',
    params,
    loadingShow: '0'
  })
}

// 培训项目简介
export const getTrainingIntroduction = (params: TrainingIntroParams): Res<TrainingIntro> => {
  return http.request({
    url: '/sands-lms/api/v1/training/introduction',
    method: 'get',
    params,
    loadingShow: '0'
  })
}

// 培训项目任务
export const getOtherTraining = (params: OtherTrainingParams): Res<OtherTrainingInterfaceData> => {
  return http.request({
    url: '/sands-lms/api/v1/activity/get',
    method: 'get',
    params
  })
}

// 培训项目任务 任务切换
export const getTrainingTask = (params: TrainingTaskParams): Res<TrainingTaskListData> => {
  return http.request({
    url: '/sands-lms/api/v1/training/tasks',
    method: 'get',
    params,
    loadingShow: '0'
  })
}

// 更新最新学习任务ID
export const getTrainingUpdate = (data: TrainingUpdateIDParams): Res<TrainingUpdateData> => {
  return http.request({
    url: '/sands-lms/api/v1/training/update-latest-learning',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 签到详情
export const getTrainingSignDetail = (params: OtherTrainingParams): Res<SignDetailData> => {
  return http.request({
    url: '/sands-lms/api/v1/sign-in/get',
    method: 'get',
    params,
    loadingShow: '0'
  })
}

// 扫码签到提交
export const getTrainingSignScan = (data: SignScanParams): Res<SignScanData> => {
  return http.request({
    url: '/sands-lms/api/v1/sign-in/scan-submit',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 请假提交
export const getTrainingSignLeave = (data: SignLeaveParams): Res<SignLeaveData> => {
  return http.request({
    url: '/sands-lms/api/v1/sign-in/ask-for-leave',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 作业详情
export const getHomeworkDetail = (params: HomeworkDescParams): Res<HomeworkDesc> => {
  return http.request({
    url: '/sands-lms/api/v1/homework/get',
    method: 'get',
    params
  })
}

// 作业提交
export const getSubmitHomework = (data: HomeworkSubmitParams): Res<TrainingUpdateData> => {
  return http.request({
    url: '/sands-lms/api/v1/homework/submit',
    method: 'post',
    data
  })
}

// 链接详情
export const getTrainingLink = (params: HomeworkDescParams): Res<TrainingLink> => {
  return http.request({
    url: '/sands-lms/api/v1/link/get',
    method: 'get',
    params,
    loadingShow: '0'
  })
}

// 链接完成提交
export const getTrainingCompleteLink = (data: HomeworkDescParams): Res<TrainingLink> => {
  return http.request({
    url: '/sands-lms/api/v1/link/complete',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 培训任务自主报名详情
export const getTrainingSelfRegistrationDetail = (data: SelfRegistrationDetailParams): Res<SelfRegistrationDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/training/selfJoinGet',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

export const getTrainingSelfRegistrationJoin = (data: SelfRegistrationDetailParams): Res<SignLeaveData> => {
  return http.request({
    url: '/sands-lms/api/v1/training/selfJoin',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

export const getTrainingOpt = (data: TrainingOptParams): Res<SignLeaveData> => {
  return http.request({
    url: '/sands-lms/api/v1/training/opt',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// 开始作业（返回页面剩余时长与记录ID）
export const startHomework = (data: { id: string | number }): Res<{
  pageRemainHomeworkTime: number
  homeworkId: number
  homeworkRecordId: number
  isUnificationTime?: number
  homeworkDuration?: number
  isIncludeExitHomeworkTime?: number
}> => {
  return http.request({
    url: '/sands-lms/api/v1/homework/startHomework',
    method: 'get',
    params: data,
    loadingShow: '0'
  })
}

// 作业心跳
export const updateHomeworkDoTime = (data: { homeworkRecordId: string | number; homeworkId: string | number }): Res<TrainingUpdateData> => {
  return http.request({
    url: '/sands-lms/api/v1/homework/updateDoTime',
    method: 'post',
    data,
    loadingShow: '0'
  })
}
